import React, {useState} from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { 
  Typography,
  Checkbox,
  Grid
 } from '@mui/material';

export default function ConfirmDialog(props) {
    const {open, handleClose, handleOk} = props;
    const [confirmCheck1, setConfirmCheck1] = useState(false);
    const [confirmCheck2, setConfirmCheck2] = useState(false);
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogContent sx={{p:2, pb:0}}>
          <DialogContentText>
            <Grid container wrap="nowrap" alignItems="start">
                <Checkbox 
                  checked={confirmCheck1}
                  onChange={(e) => setConfirmCheck1(e.target.checked)}
                />
                <Typography color="primary" variant="body1" sx={{p:1}}>     
                    <b>
                      By checking this box, I acknowledge that the information <br/>
                      I have entered in this form is true to the best of my knowledge.
                    </b>
                </Typography>
          
            </Grid>
            <Grid container wrap="nowrap" alignItems="start">
                <Checkbox 
                  checked={confirmCheck2}
                  onChange={(e) => setConfirmCheck2(e.target.checked)}
                />
                <Typography color="primary" variant="body1" sx={{p:1}}>     
                  <b>
                  By checking this box, you are acknowledging that we will automatically have rights of subrogation in respect of such loss payment(s) against the Occupier(s) and any other responsible party(ies) obligated to the terms of the tenancy agreement
                  </b>
                </Typography>
          
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button variant='contained' color="error" onClick={handleClose}>
                <Typography >
                    Cancel
                </Typography>
            </Button>
            <Button variant='contained' onClick={handleOk} autoFocus disabled={!confirmCheck1 || !confirmCheck2}>
                <Typography color="Primary">
                    Submit
                </Typography>
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
